import gql from "graphql-tag";

export default {
  mutation: gql`
    mutation blockProcessingUser($username: String!, $comment: String) {
      blockProcessingUser(
        username: $username
        isBlocked: true
        comment: $comment
      ) {
        success
      }
    }
  `,
  mutationName: "blockProcessingUser",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingUser/blockProcessingUser.js